module.exports = __webpack_public_path__ + "assets/health_black.ae833093.svg";